import { Box, Group, Text } from '@mantine/core';
import type { FC } from 'react';
import LanguageSelect from '@/components/LanguageSelect';
import { runtimeConfig } from '@/constants';
import { useHostContext } from '@/context/HostContext.tsx';
import { partnerMetadata } from '@/srcV2/services/PartnerMetadata.ts';
import { CLASS_NAMES } from './classNames';

const StepperHeader: FC = () => {
	const { localization } = useHostContext();
	const logoSrc =
		partnerMetadata.getDarkLogoUrl(true) || partnerMetadata.getDarkLogoUrl();

	if (!logoSrc) {
		console.error('No logo configured for partner:', partnerMetadata.getId());
	}

	const handleLogoError = (
		event: React.SyntheticEvent<HTMLImageElement, Event>
	) => {
		event.currentTarget.style.display = 'none';
	};

	return (
		<Box
			className={CLASS_NAMES.brandHeader}
			component="header"
			data-testid="stepper-onboarding-header"
		>
			<Box className={CLASS_NAMES.brandInner}>
				{logoSrc && (
					<img
						alt={localization.translate(
							'creator',
							'stepperOnboarding.brand.logoAlt'
						)}
						className={CLASS_NAMES.brandLogo}
						onError={handleLogoError}
						src={logoSrc}
					/>
				)}
				<Box className="flex h-full items-center justify-center">
					<hr className="m-0 ml-6 mr-6 h-6 w-px border-0 bg-[#EAEAEA] p-0" />
					<Text className="text-base font-normal tracking-normal text-[var(--color-primary-900)] m-0 h-[auto] p-0">
						<span data-testid="stepper-brand-product">
							{localization.translate(
								'creator',
								'stepperOnboarding.brand.product'
							)}
						</span>
					</Text>
				</Box>

				<Group className="ml-auto">
					{partnerMetadata.isLocalizationEnabled() &&
						!runtimeConfig.isRemoteBuild && <LanguageSelect />}
				</Group>
			</Box>
		</Box>
	);
};

export default StepperHeader;
